import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  combineLatest,
  Subscription,
} from 'rxjs';
import {
  RemoveFacetBubbleAction,
  ResetFacetBubblesAction,
  HandleFacetsLockInStorage,
} from 'search/actions/facet.actions';
import {
  getAdvancedMode,
  getAppliedFacetsArray,
  getFacetsLoading,
  State,
} from 'search/reducers/root.reducer';
import { ResourceFacet } from 'search/facets/models/resource-facet';

@Component({
  selector: 'app-search-facets',
  templateUrl: './search-facets.component.html',
  styleUrls: ['./search-facets.component.scss'],
})
export class SearchFacetsComponent implements OnInit, OnDestroy {
  public facets: ResourceFacet[];
  public resetAvailable = false;
  public facetsLoading = false;
  private isAdvancedMode = false;
  private subscriptions = new Subscription();
  constructor(private store: Store<State>) { }

  public ngOnInit() {
    this.subscriptions.add(
      combineLatest([
        this.store.pipe(select(getAppliedFacetsArray)),
        this.store.pipe(select(getFacetsLoading)),
        this.store.pipe(select(getAdvancedMode))
      ]).subscribe(
        ([appliedFacetsArray, facetsLoading, advanced]) => {
          this.isAdvancedMode = advanced;
          this.resetAvailable = appliedFacetsArray?.length && (appliedFacetsArray.some((x) => !x.isResetLocked) || advanced);
          this.facets = appliedFacetsArray as ResourceFacet[];
          this.facetsLoading = facetsLoading;
        },
      ));
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public trackByFacetId(index: number, facet: ResourceFacet): string {
    return facet.id;
  }

  public onToggleBubbleLock(facet: ResourceFacet) {
    this.store.dispatch(new HandleFacetsLockInStorage({ facet }));
  }

  public onRemoveFacetBubble(facet: ResourceFacet) {
    this.store.dispatch(new RemoveFacetBubbleAction({ facet }));
  }

  public resetFacetBubbles() {
    this.store.dispatch(new ResetFacetBubblesAction({resetAll: this.isAdvancedMode}));
  }

}
